<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <el-form-item
      label="Content Width"
      prop="content.width"
      :rules="
        numberRule(
          `content_width`,
          limit.content.min_width,
          limit.content.max_width
        )
      "
    >
      <el-input
        type="number"
        :min="limit.content.min_width"
        :max="limit.content.max_width"
        v-model.number="item.content.width"
      >
        <template slot="append">
          %</template
        >
      </el-input>
    </el-form-item>

    <div v-for="key in ['top', 'bottom', 'left', 'right']" :key="key">
      <el-form-item
        :label="_.startCase(key) + ' Image'"
        :prop="`${key}_image.url`"
        :rules="[...imageSizeRule(limited_size[key]), ...urlRule('image_url')]"
      >
        <file-input
          accept="image/jpeg, image/png, image/gif"
          v-model="item[`${key}_image`].url"
          :check_upload_image_size="{
            ...limited_size[key],
            enable: true,
          }"
        ></file-input>
      </el-form-item>
      <el-form-item
        :label="_.startCase(key) + ' Height'"
        :prop="`${key}_image.height`"
        :rules="
          numberRule(
            `${key}_image_height`,
            limit[`${key}_image`].min_height,
            limit[`${key}_image`].max_height
          )
        "
        v-if="item[`${key}_image`].hasOwnProperty('height')"
      >
        <el-input
          type="number"
          :min="limit[`${key}_image`].min_height"
          :max="limit[`${key}_image`].max_height"
          v-model.number="item[`${key}_image`].height"
        >
          <template slot="append">
            px</template
          >
        </el-input>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";

const { INSKIN } = CONSTANT.CREATIVE_DEFAULT_VALUE;

export default {
  data() {
    return {
      item: {
        content: {
          width: INSKIN.CONTENT.MAX_WIDTH,
        },
        top_image: {
          url: "",
          height: INSKIN.TOP_IMAGE.MIN_HEIGHT,
        },
        bottom_image: {
          url: "",
          height: INSKIN.BOTTOM_IMAGE.MIN_HEIGHT,
        },
        left_image: {
          url: "",
        },
        right_image: {
          url: "",
        },
      },
      limit: {
        content: {
          min_width: INSKIN.CONTENT.MIN_WIDTH,
          max_width: INSKIN.CONTENT.MAX_WIDTH,
        },
        top_image: {
          min_height: INSKIN.TOP_IMAGE.MIN_HEIGHT,
          max_height: INSKIN.TOP_IMAGE.MAX_HEIGHT,
        },
        bottom_image: {
          min_height: INSKIN.BOTTOM_IMAGE.MIN_HEIGHT,
          max_height: INSKIN.BOTTOM_IMAGE.MAX_HEIGHT,
        },
      },
      limited_size: {
        top: {
          width: {
            max: 9999,
            min: 0,
          },
          height: {
            max: 600,
            min: 400,
          },
        },
        bottom: {
          width: {
            max: 9999,
            min: 0,
          },
          height: {
            max: 150,
            min: 100,
          },
        },
        left: {
          width: {
            max: 9999,
            min: 0,
          },
          height: {
            max: 9999,
            min: 0,
          },
        },
        right: {
          width: {
            max: 9999,
            min: 0,
          },
          height: {
            max: 9999,
            min: 0,
          },
        },
      },
    };
  },
  mixins: [MixFormRule, MixCreativeForm],
  methods: {
    setData(row) {
      this.item.content.width = row.content_width;
      _.forEach(
        ["top_image", "bottom_image", "left_image", "right_image"],
        (key) => {
          this.item[key].url = decodeURI(row[`${key}_url`]);

          if (this.item[key].hasOwnProperty("height"))
            this.item[key].height = row[`${key}_height`];
        }
      );
    },
    async getData(setObj) {
      setObj.content_width = this.item.content.width;
      setObj.top_image_height = this.item.top_image.height;
      setObj.bottom_image_height = this.item.bottom_image.height;
      _.forEach(
        ["top_image", "bottom_image", "left_image", "right_image"],
        (key) => {
          setObj[`${key}_url`] = this.item[key].url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
        }
      );
      return setObj;
    },
  },
};
</script>

<style></style>
